import styled from 'styled-components';
import { spacing } from 'ui/theme';

export const StyledForm = styled.form`
  display: flex;
  flex-direction: column;
  gap: ${spacing.half};
  margin: ${spacing.base} 0;
  max-width: 400px;
`;
